import axios from 'axios'
import CryptoJS from 'crypto-js'

/* function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  let cookiePath =  (global.isOffline) ? '/next-yacht-group/' : '/'
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path="+ cookiePath;
} */

let isLogged = false;
let token = "";
let username = "";
let email = "";
let password = "";
let rememberme = false
let maioraEnabled = false
let abyachtsEnabled = false

if (global.isOffline) {
  token = global.electronStore.get("token")
  username = global.electronStore.get("username")
  maioraEnabled = (global.electronStore.has("maiora") && global.electronStore.get("maiora") == "1") ? true : false
  abyachtsEnabled = (global.electronStore.has("abyachts") && global.electronStore.get("abyachts") == "1") ? true : false
  rememberme = (global.electronStore.has("rememberme") && global.electronStore.get("rememberme") == "1") ? true : false
  email = global.electronStore.get("email")
  if (rememberme) {
    password = global.electronStore.get("password")
  }
  isLogged = (token && token !== "") ? true : false;
  if (!isLogged) localStorage.removeItem('offlineItems')
} else {
  token = localStorage.getItem("token")
  username = localStorage.getItem("username")
  maioraEnabled = (localStorage.getItem("maiora") == "1") ? true : false
  abyachtsEnabled = (localStorage.getItem("abyachts") == "1") ? true : false
  isLogged = (token && token !== "") ? true : false;
  rememberme = (localStorage.getItem("rememberme") == "1") ? true : false
  email = localStorage.getItem("email")
  if (rememberme) {
    password = localStorage.getItem("password")
    password = CryptoJS.AES.decrypt(password, "NextYacht26").toString(CryptoJS.enc.Utf8)
    console.log('decrypted password', password)
  }
  /* token = getCookie("token")
  username = getCookie("username")
  maioraEnabled = (getCookie("maiora") == "1") ? true : false
  abyachtsEnabled = (getCookie("abyachts") == "1") ? true : false
  isLogged = (token && token !== "") ? true : false;
  rememberme = (getCookie("rememberme") == "1") ? true : false
  if (rememberme) {
    email = getCookie("email")
    password = getCookie("password")
  } */
}
console.log('isLogged', isLogged)

const state = {
  isLogged: isLogged,
  token: token,
  rememberme: rememberme,
  username: username,
  email: email,
  password: password,
  maioraEnabled: maioraEnabled,
  abyachtsEnabled: abyachtsEnabled,
}

const mutations = {
  LOGIN_SUCCESS(state, payload) {
    if (payload.preservedata) {
      state.token = ''
      state.maioraEnabled = 0
      state.abyachtsEnabled = 0
      state.username = ''
      state.email = payload.email
      state.password = payload.password
      state.rememberme = payload.rememberme
      state.isLogged = false
    } else if (payload) {
      state.token = payload.token
      state.maioraEnabled = payload.maiora
      state.abyachtsEnabled = payload.abyachts
      state.username = payload.username
      state.email = payload.email
      state.password = payload.password
      state.rememberme = payload.rememberme
      state.isLogged = true
    } else {
      state.token = ''
      state.maioraEnabled = 0
      state.abyachtsEnabled = 0
      state.username = ''
      state.email = ''
      state.password = ''
      state.isLogged = false
    }
    console.log("UPDATE isLogged =>", payload);
  },
}

const actions = {
  updateUserData({ commit }, payload) {
    console.log('=> save data', payload)
    localStorage.setItem('username', payload.username)
    localStorage.setItem('token', payload.token)
    localStorage.setItem('maiora', payload.maiora)
    localStorage.setItem('abyachts', payload.abyachts)
    localStorage.setItem('email', payload.email)
    if (payload.rememberme) {
      localStorage.setItem('password', CryptoJS.AES.encrypt(payload.password, "NextYacht26").toString())
      localStorage.setItem('rememberme', 1)
    }
    commit('LOGIN_SUCCESS', payload);
  },
  async login({ rootState, commit, dispatch }, payload) {
    let apiPath = rootState.apiPath
    return axios
      .post(apiPath +'login/', payload)
      .then((response) => {
        if (response.data.error) {
          console.log(response.data.error)
          commit("LOGIN_SUCCESS", false)
          return response.data.error
        } else {
          let user = response.data
          user.rememberme = payload.rememberme
          user.password = payload.password
          dispatch('updateUserData', user)
          if (global.isOffline) {
            window.top.ipcRenderer.send('login', {
              data: user
            });
          }
          return response.data
        }
      })
      .catch((error) => {
        console.log("Login call unsuccessful :(", error);
        return error
      });
  },
  logout({ getters, commit }) {
    localStorage.removeItem('token')
    localStorage.removeItem('username')
    localStorage.removeItem('maiora')
    localStorage.removeItem('abyachts')
    localStorage.removeItem('offlineItems')
    if (!getters.rememberme) {
      localStorage.removeItem('email')
      localStorage.removeItem('password')
      localStorage.removeItem('rememberme')
    }
    if (global.isOffline) {
      global.electronStore.delete("token")
      global.electronStore.delete("username")
      global.electronStore.delete("maiora")
      global.electronStore.delete("abyachts")
    }
    if (getters.rememberme) {
      let payload = { preservedata: true, email: getters.email, password: getters.password, rememberme: getters.rememberme }
      commit('LOGIN_SUCCESS', payload);
    } else {
      commit('LOGIN_SUCCESS', false);
    }
    window.location.reload()
  },
  async saveUser({ rootState, getters, dispatch }, payload) {
    let apiPath = rootState.apiPath
    return axios
      .post(apiPath +'edituser/', payload)
      .then((response) => {
        if (response.data.error) {
          console.log(response.data.error)
        } else {
          response.data.rememberme = getters.rememberme
          response.data.password = payload.newpassword
          dispatch('updateUserData', response.data)
        }
        return response.data
      })
      .catch((error) => {
        console.log("requestAccess call unsuccessful :(", error);
        return error
      });
  },
  async requestAccess({ rootState }, payload) {
    let apiPath = rootState.apiPath
    return axios
      .post(apiPath +'requestaccess/', payload)
      .then((response) => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        return response.data
      })
      .catch((error) => {
        console.log("requestAccess call unsuccessful :(", error);
        return error
      });
  },
}

const getters = {
  isLogged: (state) => state.isLogged,
  token: (state) => state.token,
  username: (state) => state.username,
  rememberme: (state) => state.rememberme,
  email: (state) => state.email,
  password: (state) => state.password,
  maioraEnabled: (state) => state.maioraEnabled,
  abyachtsEnabled: (state) => state.abyachtsEnabled,
}

const loginModule = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}

export default loginModule
